import { useEffect, useState, Component } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Preloader from "@/components/Preloader";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Work from "@/components/Work";
import Services from "@/components/Services";
import About from "@/components/About";
import Booking from "@/components/Booking";
import Footer from "@/components/Footer";
import Testimonials from "@/components/Testimonials";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen bg-obsidian text-zinc-300 flex items-center justify-center p-8">
          <p className="font-mono text-sm">Something broke on set — reload the page.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

function Portfolio() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    lenis.stop();
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = undefined;
    };
  }, []);

  useEffect(() => {
    if (loaded && window.__lenis) window.__lenis.start();
  }, [loaded]);

  return (
    <div className="relative bg-obsidian min-h-screen">
      <Preloader onDone={() => setLoaded(true)} />
      <Nav />
      <main>
        <Hero loaded={loaded} />
        <Marquee />
        <Manifesto />
        <Work />
        <Services />
        <About />
        <Testimonials />
        <Booking />
      </main>
      <Footer />
      <div aria-hidden="true" />
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <Portfolio />
    </ErrorBoundary>
  );
}
